/*
 * ATTENTION!
 *
 * If you just want to track some events, please use `ga` from `helpers/multitrack`
 */

import PropTypes from 'prop-types';
import React from 'react';
import cookie from 'cookie';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';

const GA_INIT = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');`;

export const dimensions = {
  EXPERIMENT_BRANCH: 'dimension4',
  USER_TYPE: 'dimension8',
  EXPERIMENT: 'dimension9',
  PROMOTION: 'dimension16',
  USER_ID: 'dimension17',
};

export const getExperimentBranch = (testId, variantId) => (testId ? `test_${testId}_variant_${variantId}` : null);

// This lives outside of the component so it can be used in places that are
// not in the component heirarchy (such as sagas).
const safeGa = function ga(...args) {
  const gaFn = (__CLIENT__ || __TEST__) && typeof window.ga !== 'undefined' && window.ga;
  if (gaFn !== 'undefined' && gaFn) {
    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      console.info('Tracking ga', ...args); // eslint-disable-line no-console
    }
    gaFn(...args);
  }
};

export class GoogleAnalytics extends React.Component {
  static sendPageView = (path, customDimensions) => {
    safeGa('send', {
      page: path,
      hitType: 'pageview',
      ...customDimensions,
    });
  };

  componentDidMount() {
    const cookies = cookie.parse(document.cookie);
    safeGa('set', dimensions.USER_TYPE, cookies.cpUserType || 'prospect');
    safeGa('send', 'pageview');
  }

  componentDidUpdate(prevProps) {
    const { currentPath, userId } = this.props;

    // Track a GA page view if the URL changes
    if (currentPath !== prevProps.currentPath) {
      safeGa('send', 'pageview');
    }
    if (!prevProps.userId && userId) {
      safeGa('set', dimensions.USER_ID, String(userId));
    }
  }

  render() {
    const { accountKey, cookieDomain, userId } = this.props;

    const initLines = [];

    initLines.push(`ga('create', '${accountKey}', { cookieDomain: '${cookieDomain}' });`);

    // Optimizely Universal Analytics Integration
    initLines.push('window.optimizely = window.optimizely || [];');
    initLines.push('window.optimizely.push("activateUniversalAnalytics");');

    if (userId) {
      initLines.push(`ga('set', 'userId', '${userId}');`);
      initLines.push(`ga('set', '${dimensions.USER_ID}', '${userId}');`);
    }

    return (
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: `${GA_INIT}\n${initLines.join('\n')}`.replace(/\n/g, '') }}
      />
    );
  }
}

GoogleAnalytics.propTypes = {
  currentPath: PropTypes.string.isRequired,
  accountKey: PropTypes.string.isRequired,
  cookieDomain: PropTypes.string.isRequired,
  userId: PropTypes.number,
};
